module.exports = __webpack_public_path__ + "img/42000.f28a7c45.jpg";